import { Product, Variant } from "../../types/types";

export function isAvailableToOrder(product: Product): boolean {
  return Boolean(
    product.variants?.some((variant: Variant) =>
      Boolean(variant.availability?.availableToOrder),
    ),
  );
}
